import React from 'react';
import Wrapper from '../../Wrapper/Wrapper';
import MenuButton from '../../../components/UI/MenuButton/MenuButton';

import * as CONSTS from '../../../shared/const/Routes/Routes';
import { MENU_STRINGS } from '../../../shared/Strings';

import './Menu.scss'

const CATEGORIES = {
	[CONSTS.ROUTES.DASHBOARD]: MENU_STRINGS.DASHBOARD,
	[CONSTS.ROUTES.JOB_CONFIGURATION]: MENU_STRINGS.JOB_CONFIGURATION,
	[CONSTS.ROUTES.UPLOAD_INGREDIENT]: MENU_STRINGS.UPLOAD_INGREDIENT,
	[CONSTS.ROUTES.RELEASE_PACKAGE]: MENU_STRINGS.RELEASE_PACKAGE,
	[CONSTS.ROUTES.FARM_REPOSITORY]: MENU_STRINGS.FARM_REPOSITORY,
};

const ICON_CATEGORIES = {
	[CONSTS.ROUTES.DASHBOARD]: 'icon-dashboard',
	[CONSTS.ROUTES.JOB_CONFIGURATION]: 'icon-job-configuration',
	[CONSTS.ROUTES.UPLOAD_INGREDIENT]: 'icon-upload-ingredient',
	[CONSTS.ROUTES.RELEASE_PACKAGE]: 'icon-release-package',
	[CONSTS.ROUTES.FARM_REPOSITORY]: 'icon-farm-repository',
};

const Menu = () => {
//
  const getButtons = () => {
		const categories = Object.keys(CATEGORIES);
		let buttons = categories.map((categoryPath) => {
			return (
				<MenuButton title={CATEGORIES[categoryPath]} key={CATEGORIES[categoryPath]} path={categoryPath} iconclassName={ICON_CATEGORIES[categoryPath]} />
			);
		});
		return buttons;
	};

  return (
    <>
      <Wrapper data-test="component-menu">
			  <div className="menu-container">{getButtons()}</div>
		  </Wrapper>
    </>
  );
};
export default Menu;
